import { render, staticRenderFns } from "./carInfo.vue?vue&type=template&id=1712c0dc&"
import script from "./carInfo.vue?vue&type=script&lang=js&"
export * from "./carInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports